module.exports = {
  ENV: 'prod',
  APP_NAME: 'atlanticeau',
  END_POINT: 'https://ssm.services.apihf.com',
  API_KEY: 'BQPDIf9QsM2Pj5zLAQ6VT9H9S71mmMt14NTcvXQH',
  BRAND_KEY: 'f62acbc6-7b2e-4580-bb62-c9a2ca6f07e4',
  LANG: 'fr-FR'
}